var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M26.13 7.55a3.27 3.27 0 0 1 2.303 2.304c.55 2.036.567 6.258.567 6.258s0 4.238-.55 6.258a3.27 3.27 0 0 1-2.304 2.303c-2.019.55-10.146.55-10.146.55s-8.127 0-10.146-.55A3.27 3.27 0 0 1 3.55 22.37C3 20.334 3 16.112 3 16.112s0-4.222.534-6.242a3.27 3.27 0 0 1 2.303-2.303C7.857 7.017 15.983 7 15.983 7s8.127 0 10.147.55m-5.991 8.562-6.742 3.905v-7.81z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutube;